export const VAGINAL = { id: 'vaginal', label: 'Vaginale' };
export const SCHEDULED_CESAREAN = { id: 'scheduled_cesarean', label: 'TC programmato' };
export const URGENT_CESAREAN = { id: 'urgent_cesarean', label: 'TC urgente' };
